module.exports = __webpack_public_path__ + "static/media/cevrron-down.171577d9.svg";